import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
export var align = {
  CENTER: 'center',
  FLEX_END: 'flex-end',
  FLEX_START: 'flex-start'
};
align.ALL = _Object$values(align);
export var justify = {
  CENTER: 'center',
  FLEX_END: 'flex-end',
  FLEX_START: 'flex-start',
  SPACE_BETWEEN: 'space-between'
};
justify.ALL = _Object$values(justify);
export var directions = {
  COLUMN: 'column',
  ROW: 'row'
};
directions.ALL = _Object$values(directions);
export var flow = {
  WRAP: 'wrap'
};
flow.ALL = _Object$values(flow);
export var grow = {
  ENABLE: '1',
  DISABLE: '0'
};
grow.ALL = _Object$values(grow);
export var shrink = {
  ENABLE: '1',
  DISABLE: '0'
};
shrink.ALL = _Object$values(shrink);
export var display = {
  FLEX: 'flex',
  INLINE_FLEX: 'inline-flex'
};
display.ALL = _Object$values(display);
//# sourceMappingURL=flex.js.map